var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LayerRenderer } from './layer';
var AccessLayer = function (Card, Renderer) {
    if (!Card.prototype.NodeView)
        return Card;
    var BaseNodeView = Card.prototype.NodeView;
    var AccessNodeView = /** @class */ (function (_super) {
        __extends(AccessNodeView, _super);
        function AccessNodeView(editor, node, view, getPos) {
            var _this = _super.call(this, editor, node, view, getPos) || this;
            _this.renderer = null;
            _this.props = {
                attrs: node.attrs,
                editor: editor,
                dispatchUpdate: _this.dispatchUpdate.bind(_this),
                getBoundingClientRect: _this.getBoundingClientRect.bind(_this),
                getPos: _this.getPos,
                isSelected: false,
                wrapDOM: _this.dom,
                state: {},
            };
            return _this;
        }
        AccessNodeView.prototype.mount = function (_a) {
            var ViewMap = _a.ViewMap, layers = _a.layers;
            var renderMap = __assign(__assign({}, ViewMap), layers);
            var renderer = new LayerRenderer(this.adapter, this.dom, renderMap, {
                template: this.template,
                mask: this.mask,
            }, Renderer);
            renderer.mount(this.props);
            return (this.renderer = renderer);
        };
        // this will update view
        AccessNodeView.prototype.update = function (_a) {
            var attrs = _a.attrs, _b = _a.isSelected, isSelected = _b === void 0 ? this.isSelected : _b, isText = _a.isText;
            if (isText === true) {
                return false;
            }
            if (attrs && this.props.attrs) {
                var attrsKeys = Object.keys(attrs);
                var propsAttrsKeys_1 = Object.keys(this.props.attrs);
                if (attrsKeys.length !== propsAttrsKeys_1.length ||
                    (attrsKeys.length && attrsKeys.some(function (key) { return !propsAttrsKeys_1.includes(key); }))) {
                    return false;
                }
            }
            var result = _super.prototype.update.call(this, { attrs: attrs, isSelected: isSelected });
            var isAttrsChange = this.props.attrs !== attrs;
            var isSelectedChange = this.props.isSelected !== isSelected;
            if (isAttrsChange || isSelectedChange) {
                // this to clean observable set by Vue
                if (isAttrsChange)
                    Object.assign(this.props, { attrs: attrs });
                if (isSelectedChange)
                    Object.assign(this.props, { isSelected: (isSelected && true) || false });
                if (this.renderer) {
                    this.renderer.update(__assign({}, this.props));
                    return true;
                }
            }
            return result;
        };
        // ignored the internal mutations of the card by default, and can be overwritten if necessary
        AccessNodeView.prototype.ignoreMutation = function (event) {
            if (this.dom.contains) {
                return this.dom.contains(event.target);
            }
            else {
                return false;
            }
        };
        AccessNodeView.prototype.destroy = function () {
            _super.prototype.destroy.call(this);
            this.renderer && this.renderer.uninstall();
        };
        return AccessNodeView;
    }(BaseNodeView));
    Card.prototype.NodeView = AccessNodeView;
    return Card;
};
export { AccessLayer };
//# sourceMappingURL=card.js.map